import { ReactComponent as AccountIcon } from './assets/account.svg';
import { ReactComponent as DecreaseIcon } from './assets/arrow-decrease.svg';
import { ReactComponent as ArrowDownDoubleIcon } from './assets/arrow-down-double.svg';
import { ReactComponent as ArrowDownIcon } from './assets/arrow-down.svg';
import { ReactComponent as IncreaseIcon } from './assets/arrow-increase.svg';
import { ReactComponent as ArrowLeftIcon } from './assets/arrow-left.svg';
import { ReactComponent as ArrowLinkIcon } from './assets/arrow-link.svg';
import { ReactComponent as ArrowSeparateIcon } from './assets/arrow-separate.svg';
import { ReactComponent as NotificationsIcon } from './assets/bell.svg';
import { ReactComponent as CalendarIcon } from './assets/calendar.svg';
import { ReactComponent as CloseIcon } from './assets/cancel.svg';
import { ReactComponent as CheckIcon } from './assets/check.svg';
import { ReactComponent as ClockIcon } from './assets/clock.svg';
import { ReactComponent as UploadIcon } from './assets/cloud-upload.svg';
import { ReactComponent as CloudIcon } from './assets/cloud.svg';
import { ReactComponent as DistrictIcon } from './assets/district.svg';
import { ReactComponent as DoubleChevronLeftIcon } from './assets/double-chevron-left.svg';
import { ReactComponent as DoubleChevronRightIcon } from './assets/double-chevron-right.svg';
import { ReactComponent as DownloadIcon } from './assets/download.svg';
import { ReactComponent as DropdownIcon } from './assets/dropdown.svg';
import { ReactComponent as ExcelIcon } from './assets/excel.svg';
import { ReactComponent as EyeAltIcon } from './assets/eye-alt.svg';
import { ReactComponent as EyeIcon } from './assets/eye.svg';
import { ReactComponent as FacebookIcon } from './assets/facebook.svg';
import { ReactComponent as GridAddIcon } from './assets/grid-add.svg';
import { ReactComponent as HandIcon } from './assets/hand.svg';
import { ReactComponent as InstagramIcon } from './assets/instagram.svg';
import { ReactComponent as ListIcon } from './assets/list.svg';
import { ReactComponent as LocationPinIcon } from './assets/location-pin.svg';
import { ReactComponent as LocationIcon } from './assets/location.svg';
import { ReactComponent as LogoOneId } from './assets/logo-oneid.svg';
import { ReactComponent as MailIcon } from './assets/mail.svg';
import { ReactComponent as MapIcon } from './assets/map.svg';
import { ReactComponent as MinusIcon } from './assets/minus.svg';
import { ReactComponent as MoreIcon } from './assets/more.svg';
import { ReactComponent as NotificationsPageIcon } from './assets/notifications.svg';
import { ReactComponent as OfficeIcon } from './assets/office.svg';
import { ReactComponent as OutlineAccountIcon } from './assets/outline-account.svg';
import { ReactComponent as PageSearchIcon } from './assets/page-search.svg';
import { ReactComponent as PageStarIcon } from './assets/page-star.svg';
import { ReactComponent as PagesAddIcon } from './assets/pages-add.svg';
import { ReactComponent as PencilIcon } from './assets/pencil.svg';
import { ReactComponent as PhoneIcon } from './assets/phone.svg';
import { ReactComponent as PlayIcon } from './assets/play.svg';
import { ReactComponent as PlusIcon } from './assets/plus.svg';
import { ReactComponent as ProfileCircledIcon } from './assets/profile-circled.svg';
import { ReactComponent as CheckedIcon } from './assets/radio-checked.svg';
import { ReactComponent as UncheckedIcon } from './assets/radio-unchecked.svg';
import { ReactComponent as ReferencesIcon } from './assets/reference-books.svg';
import { ReactComponent as RefreshDoubleIcon } from './assets/refresh-double.svg';
import { ReactComponent as ReportsIcon } from './assets/report.svg';
import { ReactComponent as SolidDropdownIcon } from './assets/solid-dropdown.svg';
import { ReactComponent as StatisticsIcon } from './assets/statistics.svg';
import { ReactComponent as SwitchAccountIcon } from './assets/switch-account.svg';
import { ReactComponent as TelegramIcon } from './assets/telegram.svg';
import { ReactComponent as UserVerifiedIcon } from './assets/user-verified.svg';
import { ReactComponent as UserIcon } from './assets/user.svg';
import { ReactComponent as UsersIcon } from './assets/users.svg';
import { ReactComponent as WarningIcon } from './assets/warning-hexagon.svg';
import { ReactComponent as SearchIcon } from './assets/zoom.svg';

export {
  AccountIcon,
  ArrowDownDoubleIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowLinkIcon,
  ArrowSeparateIcon,
  CalendarIcon,
  CheckIcon,
  CheckedIcon,
  ClockIcon,
  CloseIcon,
  CloudIcon,
  DecreaseIcon,
  DistrictIcon,
  DoubleChevronLeftIcon,
  DoubleChevronRightIcon,
  DownloadIcon,
  DropdownIcon,
  ExcelIcon,
  EyeAltIcon,
  EyeIcon,
  FacebookIcon,
  GridAddIcon,
  HandIcon,
  IncreaseIcon,
  InstagramIcon,
  ListIcon,
  LocationIcon,
  LocationPinIcon,
  LogoOneId,
  MailIcon,
  MapIcon,
  MinusIcon,
  MoreIcon,
  NotificationsIcon,
  NotificationsPageIcon,
  OfficeIcon,
  OutlineAccountIcon,
  PageSearchIcon,
  PageStarIcon,
  PagesAddIcon,
  PencilIcon,
  PhoneIcon,
  PlayIcon,
  PlusIcon,
  ProfileCircledIcon,
  ReferencesIcon,
  RefreshDoubleIcon,
  ReportsIcon,
  SearchIcon,
  SolidDropdownIcon,
  StatisticsIcon,
  SwitchAccountIcon,
  TelegramIcon,
  UncheckedIcon,
  UploadIcon,
  UserIcon,
  UserVerifiedIcon,
  UsersIcon,
  WarningIcon,
};

export const Icons: Record<string, any> = {
  Account: AccountIcon,
  ArrowDownDouble: ArrowDownDoubleIcon,
  ArrowDown: ArrowDownIcon,
  ArrowLeft: ArrowLeftIcon,
  ArrowLink: ArrowLinkIcon,
  ArrowSeparate: ArrowSeparateIcon,
  Calendar: CalendarIcon,
  Check: CheckIcon,
  Close: CloseIcon,
  Cloud: CloudIcon,
  Clock: ClockIcon,
  Decrease: DecreaseIcon,
  District: DistrictIcon,
  Download: DownloadIcon,
  Dropdown: DropdownIcon,
  Excel: ExcelIcon,
  EyeAlt: EyeAltIcon,
  Eye: EyeIcon,
  GridAdd: GridAddIcon,
  Hand: HandIcon,
  Increase: IncreaseIcon,
  LogoOne: LogoOneId,
  List: ListIcon,
  Location: LocationIcon,
  Map: MapIcon,
  Minus: MinusIcon,
  More: MoreIcon,
  Notifications: NotificationsIcon,
  Office: OfficeIcon,
  OutlineAccount: OutlineAccountIcon,
  PagesAdd: PagesAddIcon,
  PageSearch: PageSearchIcon,
  PageStar: PageStarIcon,
  Pencil: PencilIcon,
  Play: PlayIcon,
  Plus: PlusIcon,
  ProfileCircled: ProfileCircledIcon,
  RefreshDouble: RefreshDoubleIcon,
  Search: SearchIcon,
  SolidDropdown: SolidDropdownIcon,
  Statistics: StatisticsIcon,
  SwitchAccount: SwitchAccountIcon,
  User: UserIcon,
  Users: UsersIcon,
  UserVerified: UserVerifiedIcon,
  Warning: WarningIcon,
  Checked: CheckedIcon,
  Unchecked: UncheckedIcon,
  DoubleChevronLeft: DoubleChevronLeftIcon,
  DoubleChevronRight: DoubleChevronRightIcon,
  Mail: MailIcon,
  Phone: PhoneIcon,
  LocationPin: LocationPinIcon,
  Facebook: FacebookIcon,
  Instagram: InstagramIcon,
  Telegram: TelegramIcon,
  Upload: UploadIcon,
  Reports: ReportsIcon,
  References: ReferencesIcon,
  NotificationsPage: NotificationsPageIcon,
};
